<template>
<div style="overflow:hidden;">
    <div :class="isLogin ? 'login in' : 'login login-out'">
        <b-container>
            <b-navbar toggleable="lg">
                    <b-navbar-brand href="#"> <img src="@/assets/img/octoffice.png" class="logo" style="width: 200px;" alt="Octoffice"></b-navbar-brand>
                    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
                    <b-collapse id="nav-collapse" is-nav>
                        <!-- Right aligned nav items -->
                        <b-navbar-nav class="ml-auto">
                            <b-nav-item target="_blank" href="https://sanatteknoloji.com.tr"> Sanat Teknoloji </b-nav-item>
                            <b-nav-item target="_blank" href="https://prosecpanel.com"> Prosec </b-nav-item>
                            <b-nav-item target="_blank" href="http://alarmpanelim.com"> Alarm Panelim </b-nav-item>
                            <b-nav-item @click="isLogin = !isLogin">{{$t('stock.fault.fTracking')}}</b-nav-item>
                            <b-nav-item-dropdown id="my-nav-dropdown" right>
                                <template slot="button-content"> <country-flag :country="activeLang.detail.flagCode" size="normal" /> {{activeLang.detail.name}} </template>
                                <b-dropdown-item v-for="lang in languages" :key="lang.detail.code" @click="changeLang(lang.detail.code)"> 
                                    <country-flag :country="lang.detail.flagCode" size="normal" /> {{lang.detail.name}}
                                </b-dropdown-item>
                            </b-nav-item-dropdown>
                        </b-navbar-nav>
                    </b-collapse>
                </b-navbar>
                <b-row class="content">
                    <b-col class="image">
                        <img class="login-pic" src="@/assets/img/loginImg.svg">
                    </b-col>
                    <b-col class="form">
                        <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
                        <template v-else>
                            <LoginForm :onLogin="onLogin"  />
                        </template>
                    </b-col>
                </b-row>
        </b-container>
        <div class="copyright">
            <a href="https://sanatteknoloji.com.tr" target="_blank"> <img class="login-pic" src="@/assets/img/sanatLogo.png"> Sanat Teknoloji tarafından geliştirilmiştir.</a>
        </div>
    </div>
    <div :class="!isLogin ? 'fs-tracking in' : 'fs-tracking out'">
        <b-navbar-nav>
            <b-nav-item @click="isLogin = !isLogin">
                <span class="go-back-btn">
                    <b-icon icon="arrow-bar-left"></b-icon>
                    {{$t('user.login.login')}}
                </span>
            </b-nav-item>
        </b-navbar-nav>
        <FaultSupportTracking :isBreadCrumb="false"/>
    </div>
</div>
</template>

<style lang="css" scoped> 
    @import "./styles/login.min.css"; 
</style>
<script>
    import CountryFlag from 'vue-country-flag'
    import i18n from '@/plugins/i18n'
    import LoginForm from './components/LoginForm'
    import FaultSupportTracking from '../../ERP/Stock/FaultSupportsTracking.vue'

    export default {
        name: "Login",
        components:{
            LoginForm, FaultSupportTracking, CountryFlag
        },
        data() {
            return { 
                isLogin: true,
                languages: Object.values(i18n.messages),
                activeLang: Object.values(i18n.messages).find( (language) => { return language.detail.code == localStorage.getItem("lang") })
            }
        },
        computed:{
            loading(){
                return this.$store.getters.getLoading
            },
            login(){
                if(this.$store.getters.login.status == 'Error'){
                    this.$bvToast.toast(this.$store.getters.login.message, {
                        title: i18n.t('user.login.loginError'),
                        variant: 'danger',
                        solid: true
                    })
                }
                return this.$store.getters.login
            },
        },
        methods:{
             changeLang: (lang) =>{
                localStorage.setItem("lang", lang)
                location.reload();
            },
            onLogin: async function(data){
                await this.$store.dispatch('login', data)
                if(this.login.data){
                    localStorage.setItem('access_token',this.login.data.access_token)
                    localStorage.setItem('refresh_token',this.login.data.refresh_token)
                    if(this.login.data.must_change_password)
                        window.location.href="/Users/ChangeDefault"
                    else
                        window.location.href="/"
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/General/Users/Login.vue